import { useResource } from '@landsbankinn/l16n';
import { useApplicationServerContext } from '../../state';

export function useHeaderTitle() {
  const [state] = useApplicationServerContext();
  const { locale } = useResource();

  const title = state.landsbankiClient
    ? state.clientName[locale]
    : 'Landsbankinn';

  return title;
}
